import React from 'react'
import { Link } from 'react-static'

class SectionTitle extends React.Component {
  render() {
    const iconUrl =  require(`../static/img/${this.props.icon}`)
    let align = this.props.align && this.props.align.length > 0 ? `section-title--align-${this.props.align}` : ''
    let titleMarginLarge = this.props.titleMarginLarge ? `section-title__copy--mb-lg` : ''
    let titleClasses = this.props.titleClasses && this.props.titleClasses.length > 0 ? this.props.titleClasses : ''
    return (
      <React.Fragment>
        <div className={`section-title ${align}`}>
          <div className="section-title__icon" style={{ backgroundImage: `url(${iconUrl})` }}></div>
          <h2 className={`section-title__copy ${titleMarginLarge} ${titleClasses}`}>{this.props.title}</h2>
        </div>
      </React.Fragment>
    )
  }
}

export default SectionTitle;



// WEBPACK FOOTER //
// /Users/terrymasher/Development/glenbeigh-ltd/src/components/Section-Title.js